import { render, staticRenderFns } from "./animationTab.vue?vue&type=template&id=6ed8486f&scoped=true&"
import script from "./animationTab.vue?vue&type=script&lang=js&"
export * from "./animationTab.vue?vue&type=script&lang=js&"
import style0 from "./animationTab.vue?vue&type=style&index=0&id=6ed8486f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed8486f",
  null
  
)

export default component.exports